import {useApi} from "../Api";
import {PeakEntityResponse} from "../types/peak";
import {PeakAssociationRequest, PeakAssociationResponse, PeakDetail, PostPeakMatrix} from "../types/peakDetail";

export const usePeakDetailRepository = () => {
    const {GET, POST, PUT} = useApi();

    const PATH = "/pricing/peak-rate-detail";

    function postPeakMatrix(associationRequest: PostPeakMatrix): Promise<PeakEntityResponse> {
        return POST(`${PATH}/create-peak-matrix`, associationRequest);
    }

    function updatePeakMatrix(associationRequest: PeakAssociationRequest): Promise<PeakAssociationResponse> {
        return PUT(`${PATH}/update-peak-matrix`, associationRequest);
    }

    function getPeakMatrix(peakId: PeakEntityResponse["id"]): Promise<PeakDetail[]> {
        return GET(`${PATH}/get-peak-matrix?peakRateId=${peakId}`);
    }

    return {
        postPeakMatrix,
        updatePeakMatrix,
        getPeakMatrix
    };
};
